// extracted by mini-css-extract-plugin
module.exports = {"banner":"z9rdi","avatar":"aJYLg","info":"npQnn","title":"QHEqz","description":"OTCNm"};